import { useEffect } from 'react';
import { useRouter } from 'next/router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({ showSpinner: false, trickleSpeed: 120, minimum: 0.08 });

const normalizePath = (path) => (path || '/').split('?')[0].replace(/\/$/, '') || '/';

/**
 * Top loading bar on client-side route changes (sidebar menu, Link, router.push).
 */
const RouteProgress = () => {
	const router = useRouter();

	useEffect(() => {
		NProgress.done();

		let safetyTimer;

		const clearSafetyTimer = () => {
			if (safetyTimer) {
				clearTimeout(safetyTimer);
				safetyTimer = undefined;
			}
		};

		const onStart = (url) => {
			const next = normalizePath(url);
			const current = normalizePath(router.asPath);
			if (next === current) return;

			NProgress.start();
			clearSafetyTimer();
			safetyTimer = setTimeout(() => NProgress.done(), 8000);
		};

		const onDone = () => {
			clearSafetyTimer();
			NProgress.done();
		};

		router.events.on('routeChangeStart', onStart);
		router.events.on('routeChangeComplete', onDone);
		router.events.on('routeChangeError', onDone);

		return () => {
			clearSafetyTimer();
			NProgress.done();
			router.events.off('routeChangeStart', onStart);
			router.events.off('routeChangeComplete', onDone);
			router.events.off('routeChangeError', onDone);
		};
	}, [router.events, router.asPath]);

	return null;
};

export default RouteProgress;
